module.exports = __webpack_public_path__ + "img/send-doubts.1795fe87.svg";